

exports.__esModule = true;
exports.$SidebarAddShippingRoute = undefined;

var _squid = require('squid');

require('./directive');

require('xo-member-components/src/select-shipping/add-shipping/route');

var $SidebarAddShippingRoute = exports.$SidebarAddShippingRoute = _squid.$ComponentRoute.extend('$SidebarAddShippingRoute', {

    path: 'sidebarAddShipping',
    directive: 'xo-sidebar-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        templateName: 'tray/addShippingAddress.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token'
        },
        message: 'message',
        sidebar: 'sidebar',
        'parent-callbacks': 'callbacks'
    }]
});

angular.value("$SidebarAddShippingRoute", $SidebarAddShippingRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-shipping/route.js
 ** module id = 323
 ** module chunks = 1
 **/